import { defineStore } from 'pinia';
import { IPopularLink } from '../../../interfaces/Navigation';
interface IState {
    navigationType: string;
    activeNavItem: string | null;
    desktopSearchNavIsOpen: boolean;
    popularTopics: IPopularLink[];
    popularKeywords: string[];
}

export const useDesktopNavStore = defineStore('desktopNavStore', {
    state: (): IState => {
        return {
            navigationType: '',
            activeNavItem: '',
            desktopSearchNavIsOpen: false,
            popularTopics: [],
            popularKeywords: [],
        };
    },
    getters: {
        getNavigationType(state) {
            return state.navigationType;
        },
        getActiveNavItem(state) {
            return state.activeNavItem;
        },
        getSearchNavState(state) {
            return state.desktopSearchNavIsOpen;
        },
    },
    actions: {
        setPopularKeywords(keywords: string[]) {
            this.popularKeywords = keywords;
        },
        setPopularTopics(topics: Array<IPopularLink>) {
            this.popularTopics = topics;
        },
        setNavigationType(type: string) {
            this.navigationType = type;
        },
        setActiveNavItem(item: string | null) {
            this.activeNavItem = item;
        },
        toggleSearchNav() {
            this.desktopSearchNavIsOpen = !this.desktopSearchNavIsOpen;
        },
    },
});
